import React from 'react';
import styles from './EmptyState.module.scss';

const EmptyState = ({ icon = '📋', title = 'No data found', message = '', className = '' }) => (
  <div className={`${styles.wrapper} ${className}`}>
    <span className={styles.icon}>{icon}</span>
    <h4 className={styles.title}>{title}</h4>
    {message && <p className={styles.message}>{message}</p>}
  </div>
);

export default EmptyState;
